module.exports = __webpack_public_path__ + "img/Size=24, Style=solid.cfd5ae30.svg";